import React from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import './styles.css';
import {convertPipeToBrTag} from "../../utils";

/**
 * PromoNavigation
 */
const PromoNavigation = ({
                           containerId,
                           containerClass,
                           link,
                           children,
                         }) => {
  //
  const getPcText = () => {
    if (link) {
      if (link.pcText && link.pcText !== '') {
        return link.pcText;
      }
      return link.pageName;
    } else {
      return '';
    }
  };
  const getMbText = () => {
    if (link) {
      if (link.mbText && link.mbText !== '') {
        return link.mbText;
      } else {
        if (link.pcText && link.pcText !== '') {
          return link.pcText;
        }
      }
      return link.pageName;
    } else {
      return '';
    }
  };
  return (
    <Wrapper
      containerId={containerId}
      containerClass={containerClass}
    >
      <section className="PromoNavigation">
        <div className="PromoNavigation__container">
          {(() => {
            if (link && link.href) {
              // リンクの設定があった場合
              return (
                <h3 className="PromoNavigation__heading">
                  <a className="PromoNavigation__link"
                     href={link.href}
                     target={(link !== null && link.targetBlank !== null && link.targetBlank === true) ? '_blank': null}
                  >
                    <span className="PromoNavigation__heading-pc">
                      <span dangerouslySetInnerHTML={{__html: convertPipeToBrTag(getPcText())}}/>
                    </span>
                    <span className="PromoNavigation__heading-mb">
                      <span dangerouslySetInnerHTML={{__html: convertPipeToBrTag(getMbText())}}/>
                    </span>
                    <span className="PromoNavigation__heading-text">TOP</span>
                    <span className="PromoNavigation__link-border"/>
                  </a>
                </h3>
              )
            } else {
              // リンクの設定がなかった場合
              return (
                <div>
                  <h3 className="PromoNavigation__heading">
                    <span className="PromoNavigation__heading-pc">
                      <span dangerouslySetInnerHTML={{__html: convertPipeToBrTag(getPcText())}}/>
                    </span>
                    <span className="PromoNavigation__heading-mb">
                      <span dangerouslySetInnerHTML={{__html: convertPipeToBrTag(getMbText())}}/>
                    </span>
                  </h3>
                </div>
              )
            }
          })()}
          <ul className="PromoNavigation__list-ul">
            {(children !== null) ?
              children.map((child, index) => {
                return (
                  <li key={index}>{child}</li>
                )
              })
              : null}
          </ul>
        </div>
      </section>
    </Wrapper>
  )
};
PromoNavigation.propTypes = {
  containerId: PropTypes.string,
  containerClass: PropTypes.string,
  link: PropTypes.shape({
    pageName: PropTypes.string,
    pcText: PropTypes.string,
    mbText: PropTypes.string,
    href: PropTypes.string,
    targetBlank: PropTypes.bool,
  }),
  children: PropTypes.arrayOf(PropTypes.node),
};
PromoNavigation.defaultProps = {
  containerId: null,
  containerClass: null,
  link: null,
  children: null,
};
export default PromoNavigation;



// WEBPACK FOOTER //
// ./src/containers/promo-navigation/index.jsx